module.exports = __webpack_public_path__ + "static/img/img_p1_1_code.837dbcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p1_1_code.png
// module id = Otmd
// module chunks = 1